export var getErrorMessage = function getErrorMessage(r) {
  return r instanceof Error ? r.message : String(r);
};